module.exports = __webpack_public_path__ + "static/media/LOGO BLIPBLA.d0cf31f6.png";